module.exports = {
	TOASTR_ERROR: 'TOASTR_ERROR',
	TOASTR_SUCCESS: 'TOASTR_SUCCESS',
	TOASTR_RESET: 'TOASTR_RESET',
	SET_BACKPATH: 'SET_BACKPATH',
	WAIT: 'WAIT',
	RECEIVE_USER_INFORMATIONS: 'RECEIVE_USER_INFORMATIONS',
	RECEIVE_USER_ROLES: 'RECEIVE_USER_ROLES',
	RECEIVE_MODAL_LOGIN_STATE: 'RECEIVE_MODAL_LOGIN_STATE',
	RECEIVE_MODAL_ACTIONS: 'RECEIVE_MODAL_ACTIONS',
	TITLE: 'TITLE',
	ACTIONS: 'ACTIONS',
	SET_EXTERNAL_LINK: 'SET_EXTERNAL_LINK',
	PATH_HOME: '/',
	PATH_MAIN: '/main',
	PATH_SELECTION: '/myResearch',
	PATH_LOGIN: '/login',
	PATH_SIGNUP: '/signup',
	PATH_INIT_ACCOUNT: '/initAccount',
	PATH_FIND_EMAIL: '/findEmail',
	PATH_RESET_PWD: '/resetPassword',
	PATH_STATION: '/station/:id',
	PATH_POINT: 'point/',
	PATH_POINT_ID: 'point/:id/:typeId',
	PATH_ADMINISTRATION: '/administration',
	PATH_ADMINISTRATION_RESEARCH: '/administration/research',
	PATH_ADMINISTRATION_ACCOUNT: '/administration/account',
	PATH_ADMINISTRATION_MAP: '/administration/map',
	PATH_ADMINISTRATION_THEME: '/administration/theme',
	PATH_ADMINISTRATION_SOURCE: '/administration/source',
	PATH_ADMINISTRATION_CREDIT: '/administration/credit',
	PATH_RESEARCH: '/research'
}



// WEBPACK FOOTER //
// ./src/home/constants/HomeConstants.js